import { render } from "./DefaultTemplate.vue?vue&type=template&id=6a0e4364"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js"

import "./DefaultTemplate.vue?vue&type=style&index=0&id=6a0e4364&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__